import styled, { css } from 'styled-components';

const MainContainer = styled.div`
  background-color: black;
  color: white;
`;

const AreaContainer = styled.div`
  display: flex;
  gap: 24px;
  ${({ isMobile }) => {
    return (
      isMobile &&
      css`
        flex-direction: column;
      `
    );
  }}
`;

export { MainContainer, AreaContainer };
